function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import pick from 'lodash/pick';
import Loader from '@domain-group/fe-co-loader';
import { addListener } from '@domain-group/fe-helper';
import { Global } from '@emotion/core';
import { ModalLoading } from './components/modal-loading';
import { ModalWindow } from './components/modal-window';
import * as styles from './modal.style';
import { scopeTab } from './util/scope-tab';
import { jsx as ___EmotionJSX } from "@emotion/core";
var TAB_KEY = 9;
var ESC_KEY = 27;
export class Modal extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "closeRefMap", void 0);
    _defineProperty(this, "pageYOffset", void 0);
    _defineProperty(this, "bodyTop", void 0);
    _defineProperty(this, "lastFocus", null);
    _defineProperty(this, "removeListener", void 0);
    _defineProperty(this, "timer", void 0);
    _defineProperty(this, "modalWrapper", null);
    _defineProperty(this, "setWrapperRef", content => {
      this.modalWrapper = content;
    });
    _defineProperty(this, "setCloseRef", (content, type) => {
      this.closeRefMap[type] = content;
    });
    _defineProperty(this, "modalCloseCallback", event => {
      if (this.props.hasCloseAnimation) {
        this.setState({
          showCloseAnimation: true
        }, () => {
          this.timer = setTimeout(() => {
            var _this$props$closeCall, _this$props;
            (_this$props$closeCall = (_this$props = this.props).closeCallback) === null || _this$props$closeCall === void 0 ? void 0 : _this$props$closeCall.call(_this$props, event);
          }, 300);
        });
      } else {
        var _this$props$closeCall2, _this$props2;
        (_this$props$closeCall2 = (_this$props2 = this.props).closeCallback) === null || _this$props$closeCall2 === void 0 ? void 0 : _this$props$closeCall2.call(_this$props2, event);
      }
    });
    _defineProperty(this, "closeModal", event => {
      var _this$getWrapperRef;
      var isParent = event.target.contains((_this$getWrapperRef = this.getWrapperRef()) !== null && _this$getWrapperRef !== void 0 ? _this$getWrapperRef : null);
      if (isParent) {
        this.modalCloseCallback(event);
      }
    });
    _defineProperty(this, "getModalLoadingProps", () => _objectSpread(_objectSpread({}, pick(this.props, ['loader', 'loading'])), {}, {
      isAnimated: this.isAnimated()
    }));
    _defineProperty(this, "getModalWindowProps", () => _objectSpread(_objectSpread({}, pick(this.props, ['appearance', 'height', 'hideXToClose', 'idealHeight', 'idealWidth', 'innerStyle', 'loading', 'width'])), {}, {
      closeRef: this.setCloseRef,
      isAnimated: this.isAnimated(),
      onClose: this.modalCloseCallback
    }));
    _defineProperty(this, "handleKeyDown", event => {
      if (event.keyCode === TAB_KEY) {
        scopeTab(this.getWrapperRef(), event);
      }
      if (event.keyCode === ESC_KEY) {
        event.preventDefault();
        this.modalCloseCallback(event);
      }
    });
    _defineProperty(this, "isAnimated", () => {
      var _ref;
      return (_ref = this.props.animated && !this.state.showCloseAnimation) !== null && _ref !== void 0 ? _ref : false;
    });
    this.state = {
      showCloseAnimation: false
    };
    this.closeRefMap = {};
  }
  componentDidMount() {
    if (this.props.restoreScrollPosition) {
      this.pageYOffset = window.pageYOffset;
      this.bodyTop = document.body.style.top;
      document.body.style.top = "".concat(-this.pageYOffset, "px");
      document.body.classList.add('body-no-scroll');
    }
    this.lastFocus = document.activeElement;
    var initialFocusRef = this.props.initialFocusRef;
    if (initialFocusRef && 'current' in initialFocusRef && initialFocusRef.current) {
      initialFocusRef.current.focus();
    } else {
      this.focusClose();
    }
    this.removeListener = addListener(document, 'keydown', this.handleKeyDown);
  }
  UNSAFE_componentWillReceiveProps(newProps) {
    if (!newProps.loading && this.props.loading) {
      this.focusClose();
    }
  }
  componentWillUnmount() {
    var _this$removeListener;
    if (this.lastFocus) {
      this.lastFocus.focus();
    }
    if (this.props.restoreScrollPosition) {
      var _this$bodyTop, _this$pageYOffset, _this$pageYOffset2;
      document.body.classList.remove('body-no-scroll');
      document.body.style.top = (_this$bodyTop = this.bodyTop) !== null && _this$bodyTop !== void 0 ? _this$bodyTop : '';
      document.documentElement.scrollTop = (_this$pageYOffset = this.pageYOffset) !== null && _this$pageYOffset !== void 0 ? _this$pageYOffset : 0;
      document.body.scrollTop = (_this$pageYOffset2 = this.pageYOffset) !== null && _this$pageYOffset2 !== void 0 ? _this$pageYOffset2 : 0;
    }
    (_this$removeListener = this.removeListener) === null || _this$removeListener === void 0 ? void 0 : _this$removeListener.call(this);
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }
  getWrapperRef() {
    return this.modalWrapper;
  }
  focusClose() {
    var refs = this.closeRefMap;
    Object.values(refs).forEach(ref => ref && ref.focus());
  }
  render() {
    var _this$props3 = this.props,
      className = _this$props3.className,
      children = _this$props3.children,
      style = _this$props3.style,
      appearance = _this$props3.appearance;
    var isAnimated = this.isAnimated();
    var isCloseAnimation = this.state.showCloseAnimation;
    return ___EmotionJSX("div", {
      css: styles.modal(appearance, isAnimated, isCloseAnimation),
      onClick: this.closeModal,
      style: style,
      className: className,
      ref: this.setWrapperRef
    }, ___EmotionJSX(Global, {
      styles: styles.globalStyles
    }), typeof children === 'function' ? children({
      getModalLoadingProps: this.getModalLoadingProps,
      getModalWindowProps: this.getModalWindowProps
    }) : ___EmotionJSX(React.Fragment, null, ___EmotionJSX(ModalWindow, this.getModalWindowProps(), children), ___EmotionJSX(ModalLoading, this.getModalLoadingProps())));
  }
}
_defineProperty(Modal, "defaultProps", {
  closeCallback: () => {},
  hideXToClose: false,
  appearance: 'minimal',
  animated: true,
  hasCloseAnimation: false,
  loader: ___EmotionJSX(Loader, {
    transparent: true,
    dark: true
  }),
  initialFocusRef: null,
  loading: false,
  restoreScrollPosition: true
});